import React, { useState, useEffect } from 'react';

import closeIcon from '../../../../../Assets/images/close-icon.svg';
import mailIcon from '../../../../../Assets/images/mail-icon.svg';

import { jwtDecode } from 'jwt-decode';
import Loader from '../../../../../Context/Loader/Loader';
import apiClient from '../../../../../Config/apiClient';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';

const basePath = process.env.REACT_APP_SERVER_BASE_URL;
const signInPath = process.env.REACT_APP_TC_SIGNIN_BASE_PATH;

const ResetPassword = ({ onClose, token }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState('form');

    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setEmail(decoded.email);
            } catch (err) {
                setError('Invalid or expired token');
            }
        }
    }, [token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email.trim() || !token) {
            setError('Invalid reset request');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await apiClient.post(`${basePath}${signInPath}/reset-password`, { email, token });

            if (response.status === 200) {
                setCurrentStep('confirmation');
            }
        } catch (err) {
            const msg = err.response? err.response.data.message : err.message;
            console.error(msg);
            showErrorToast(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="form-cvr" style={{ display: 'block' }}>
            {currentStep === 'form' && (
                <div className="h-form signin-form">
                    <button className="close-button" onClick={onClose} type="button">
                        <img src={closeIcon} alt="Close" />
                    </button>
                    <div className="otp-header">
                        <h1>Reset Password?</h1>
                        <p className="fp-text">
                            You're about to reset your password. For your security, please confirm that you requested this password reset.
                        </p>
                    </div>

                    <form className="hform-inner-small" onSubmit={handleSubmit}>
                        <div className="hf-split c-name">
                            <label className="fi-label">
                                Email address <span>*</span>
                            </label>
                            <input type="email" className="common-input" value={email} disabled />
                            {error && <p className="error-text active" style={{ textTransform: 'none' }}>{error}</p>}
                        </div>
                        <div className="field fp-field">
                            <button type="submit" className="firstNext next h-btn right-btn" disabled={loading}>
                                {loading ? <Loader /> : 'Submit'}
                            </button>
                        </div>
                    </form>
                </div>
            )}

            {currentStep === 'confirmation' && (
                <div className="h-form otp-form">
                    <div className="mail-image">
                        <img src={mailIcon} alt="Mail Icon" />
                    </div>
                    <div className="otp-header">
                        <h1>Reset Link Sent</h1>
                        <p className="fp-text">
                            Please check your email inbox for<br />
                            your temporary password
                        </p>
                    </div>
                    <div className="hform-inner">
                        <div className="hotp-split mb-0">
                            <div className="ob-cvr">
                                <button type="button" className="h-btn ms-0 mt-0" onClick={onClose}>
                                    Back to Sign In
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ResetPassword;